import { ReactNode } from "react";
import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";

const Title: FCX<{
    subTitle?: ReactNode;
}> = ({
    className,
    children,
    subTitle,
    testId,
    ...props
}) => {
    return (
        <div
            className={cn(
                "Title",
                className,
            )}
            data-testid={testId}
            {...props}
        >
            {children}
            {subTitle && (
                <div
                    className="Title__sub cl-secondary"
                    data-testid={`${testId}Sub`}
                >
                    {subTitle}
                </div>
            )}
        </div>
    );
};

export default Title; 